import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ADMIN_PATH } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import WheelPage from "@/pages/WheelPage";
import ScratchPage from "@/pages/ScratchPage";
import MemoryPage from "@/pages/MemoryPage";
import RunnerPage from "@/pages/RunnerPage";
import CaissePage from "@/pages/CaissePage";
import AdminPage from "@/pages/AdminPage";
import VoucherPage from "@/pages/VoucherPage";
import AccountPage from "@/pages/AccountPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/roue" element={<WheelPage />} />
          <Route path="/grattage" element={<ScratchPage />} />
          <Route path="/memory" element={<MemoryPage />} />
          <Route path="/runner" element={<RunnerPage />} />
          <Route path="/caisse" element={<CaissePage />} />
          <Route path="/compte" element={<AccountPage />} />
          <Route path="/v/:code" element={<VoucherPage />} />
          {/* Back-office : chemin secret configurable (REACT_APP_ADMIN_PATH) */}
          <Route path={`/${ADMIN_PATH}`} element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
